import React, { useCallback, useState } from "react";
import { useFormik } from "formik"
// import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { useTheme } from '~/ui/styled'
import { useSafeAreaInsets } from "~/ui/safe-area"
import { Flex, ColumnFlex, StartFlex, CenterFlex, BetweenFlex, Text, Button, GradientButton, IconFont } from "~components/El"
import { TextField, MultiLineTextField } from "~components/InputField";
import { Tooltip } from "~components/Layout";
import { withPopupScrollable } from "~hoc/withPopupScrollable"
import { TransferSchema } from "~schema"
import { usePopup } from "~hooks/usePopup"
import { useStores } from "~models"
import useGroupActions from "~hooks/useGroupActions"
import { Theme } from "~theme/styled";
import { globalToast } from "~utils";
import QuickButtons from "../components/QuickButtons";
import MemberListView from "../components/MemberListView";
import MemberItemContent from "../components/MemberItemContent";

const LabelContent: React.FC<{ theme: Theme; label: string; content: string; count?: string | number}> = ({ theme, label = "", content = "", count = 0 }) => {
    return (
        <BetweenFlex width="100%">
            <StartFlex>
                <Text fontSize="14px" color={theme.colors.text} fontWeight={600} mr="4px">{label}</Text>
                 <Tooltip content={<Text color={theme.colors.textLight} fontSize="12px">{content}</Text>}>
                    <IconFont name="xttz" color={theme.colors.secondary} size={14}/>
                 </Tooltip>
                
            </StartFlex>
            
            <Text fontSize="14px" color={theme.colors.secondary}>单笔转账金额不超过{count}元</Text>
        </BetweenFlex>
    )
}
const PrefixContent: React.FC<{ theme: Theme; text: string; }> = ({ theme, text = "" }) => (
    <GradientButton
        width={16}
        height={16}
        colors={['#fb994d', '#ee4b49']}
        borderRadius={8}
        style={{ marginLeft: 12 }}
        onClick={() => { } } >
        <Text fontSize="14px" color={theme.colors.textLight}>{text}</Text>
    </GradientButton>
)

const TransferForm: React.FC<{ member?: any, popupId?: number, channelChatInfo?: any }> = ({ member, popupId, channelChatInfo }) => {
    const theme = useTheme()
    const insets = useSafeAreaInsets()
    const popup = usePopup();
    const { onChatTransfer } = useGroupActions();
    const { chatStore, walletStore } = useStores()
    const [loading, setLoading] = useState(false)
    const current = chatStore.current ?? {}
    const chatTypeEnum = current?.chatTypeEnum

    const formik = useFormik({
        initialValues: {
            amount: "",
            remark: "",
            wp_password: "",
            member: member
        },
        validationSchema: TransferSchema(channelChatInfo?.transfer_max_amount),
        onSubmit: (values) => {
            if (loading) return
            if (!values.member) {
                globalToast.show("请选择转账对象")
                return
            }
            if (chatTypeEnum === "PRIVATE" && !current.id) {
                globalToast.show("请先发送一条文本消息确认身份")
                return
            }
            setLoading(true)
            // console.log("提交成功", values);
            onChatTransfer({
                chat_id: current.id,
                chat_cid: current.chat_id,
                amount: values.amount,
                remark: values.remark,
                wp_password: values.wp_password,
                user_id: values.member?.user_id || values.member?.id
            }, (data) => {
                // 刷新获取账号余额的接口
                walletStore.getWalletInfo()
                setLoading(false)
                // popup?.close(popupId)
            }, (error) => {
                setLoading(false)
                // console.log("error---", error);
                globalToast.show(error?.message || "转账失败")
            })
            popup?.close(popupId)
        },
    });
    const { values, errors, touched, setFieldValue, handleSubmit } = formik;
    

    const onMemberChange = useCallback((member) => {
        setFieldValue("member", member);
    }, [])

    const handleOpenContact = useCallback(async() => {
        const p = popup.open({
            stack: true,
            content: (
                <MemberListView
                type="transfer"
                onMemberChange={(member) => {
                    onMemberChange(member)
                    popup.close(p.id)
                }}
                onClose={() => popup.close(p.id)}
                />
            ),
            type: "center"
        });
    }, [popup, onMemberChange]);

    return (
        <ColumnFlex
            height="auto"
            width="100%"
            padding="12px"
            borderRadius="16px"
            bg={theme.colors.blockBackground}
        >
            <StartFlex height="auto" width="100%">
                <GradientButton
                    flexShrink={0}
                    width={34}
                    height={34}
                    colors={['#fb994d', '#ee4b49']}
                    borderRadius={17}
                    onClick={() => { } } >
                    <IconFont name="hb1" color={theme.colors.textLight} size={16} />
                </GradientButton>
                <Flex width='auto' height="auto" flexDirection="column" ml="10px">
                    <Text fontSize="16px" color={theme.colors.text} fontWeight={600}>转账给</Text>
                </Flex>
            </StartFlex>
            <Flex height="auto" flexDirection="column" width="100%" mt="10px">
                {current?.chatTypeEnum === "GROUP" && (
                    <>
                        {values.member && (<MemberItemContent member={values.member} onClick={() => {
                            setFieldValue("member", null);
                        }} /> )}
                        {!values.member && ( 
                            <Button
                                flexDirection="column"
                                width="100%"
                                height="68px"
                                borderRadius="8px"
                                border={`1px solid ${theme.colors.border}`}
                                bg={theme.colors.background}
                                onClick={handleOpenContact}
                            >
                                <CenterFlex
                                    width="24px"
                                    height="24px"
                                    borderRadius="12px"
                                    border={`1px solid ${theme.colors.secondary}`}
                                >
                                    <IconFont name="nc" color={theme.colors.secondary} size={14}/>
                                </CenterFlex>
                                <Text fontSize="14px" color={theme.colors.secondary} mt="5px">点击选择群成员</Text>
                            </Button>
                        )}
                    </>
                )}
                
        
                <TextField
                    label={<LabelContent theme={theme} label="转账金额" content={`单笔转账金额不超过${channelChatInfo?.transfer_max_amount || 10000}元`} count={channelChatInfo?.transfer_max_amount || 10000} />}
                    prefix={<PrefixContent theme={theme} text="¥" />}
                    value={values.amount}
                    placeholder="请输入金额"
                    keyboardType="decimal-pad"
                    onChangeText={(value) => setFieldValue("amount", value)}
                    error={touched.amount && errors.amount}
                />
                <QuickButtons
                    value={values.amount}
                    options={["10", "50", "100", "200", "500", "1000", "2000", "3000"]}
                    onChange={(v) => setFieldValue("amount", v)}
                />
                <TextField
                    label="支付密码"
                    value={values.wp_password}
                    placeholder="请输入支付密码"
                    keyboardType="numeric"
                    maxLength={6}
                    secureTextEntry
                    required
                    onChangeText={(v) => setFieldValue("wp_password", v)}
                    error={touched.wp_password && errors.wp_password}
                />
                <Flex flexDirection="column" width="100%" mt="10px">
                    <MultiLineTextField
                        value={values.remark}
                        placeholder="请输入转账说明"
                        maxLength={30}
                        style={{ height: 80  }}
                        onChangeText={(v) => setFieldValue("remark", v)}
                        error={touched.remark && errors.remark}
                    />
                </Flex>
                <BetweenFlex
                    width="100%"
                    padding="12px"
                    borderRadius="8px"
                    bg={theme.colors.background}
                    mt="10px"
                >
                    <Text fontSize="14px" color={theme.colors.text}>钱包余额</Text>
                    <Text fontSize="14px" color={theme.colors.text} fontWeight="600">¥{walletStore?.balance || '0'}</Text>
                </BetweenFlex>
            </Flex>
            <BetweenFlex width="100%" padding="12px 0" mb={insets.bottom}>
                <Button
                    width="48%"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.background}
                    onClick={() => {
                        popup?.close(popupId)
                    }}
                >
                    <Text color={theme.colors.infoText} fontSize={16}>取消</Text>
                </Button>
                <GradientButton
                    width="48%"
                    height={44}
                    colors={['#fb994d', '#ee4b49']}
                    borderRadius={8}
                    loading={loading}
                    disabled={loading}
                    onClick={handleSubmit}
                >
                    <Text color={theme.colors.textLight} fontSize={16}>确认转账</Text>
                </GradientButton>
            </BetweenFlex>
        </ColumnFlex>
    )
}

export default observer(withPopupScrollable(TransferForm))
